// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-text ul {
  list-style-type: none;
  padding-left: 0;
}

.card-text li {
  list-style-type: none;
}

.study-list-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  width: 100%;
}

.study-list-card {
  flex: 0 0 calc(50% - 20px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  min-height: 100%;
  width:100% ;
  /* padding: 24px;
  border: 1px solid var(--color-gray);
  border-radius: 8px;
  background: var(--color-white);
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.06); */
}

.study-list-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.study-list-actions {
  margin-top: auto;
  display: flex;
  align-items: flex-start;
}

.study-list-actions .primary-button {
  margin-top: 8px;
}

@media (max-width: 767px) {
  .study-list-card {
    flex: 1 0 100%;
  }

  .study-list-actions {
    justify-content: flex-start;
  }
}

:host a {
  text-decoration: none;
  color: inherit;
}

:host .primary-button {
  color: var(--color-white) !important;
}
/* LSR-scoped typography and base styles */
:host {
  display: block;
  width: 100%;
  font-family: var(--font-main);
}

:host h1,
:host h2,
:host h3,
:host p,
:host ul {
  margin: 0;
}

:host h1 {
  font-size: 60px;
  line-height: 1.2;
  font-weight: 400;
}

:host h2 {
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple);
}

:host p,
:host ul {
  font-size: 18px;
  line-height: 1.18;
}

:host ul {
  max-width: 563px;
  padding-left: 24px;
}

:host li::marker {
  font-size: 10px;
}

:host a {
  color: inherit;
}

:host a.primary-button,
:host a.primary-button:link,
:host a.primary-button:visited {
  color: var(--color-white);
  text-decoration: none;
}

:host a.primary-button:hover,
:host a.primary-button:focus-visible {
  color: var(--color-white);
  text-decoration: none;
}

:host p a {
  color: var(--color-green);
}

:host img {
  display: block;
  max-width: 100%;
  height: auto;
  border: 0;
}

:host section {
  scroll-margin-top: 120px;
}

@media (max-width: 1024px) {
  :host h1 {
    font-size: 48px;
    line-height: 1.12;
  }
}

@media (max-width: 767px) {
  :host h1 {
    font-size: 38px;
  }

  :host h2 {
    font-size: 26px;
  }

  :host p,
  :host ul {
    font-size: 16px;
    line-height: 1.35;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/LSR/participant/participant_study_list/participant_study_list.component.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX;;;;gDAI8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;AACA,0CAA0C;AAC1C;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;;;;EAKE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".card-text ul {\r\n  list-style-type: none;\r\n  padding-left: 0;\r\n}\r\n\r\n.card-text li {\r\n  list-style-type: none;\r\n}\r\n\r\n.study-list-grid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 40px;\r\n  width: 100%;\r\n}\r\n\r\n.study-list-card {\r\n  flex: 0 0 calc(50% - 20px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  min-height: 100%;\r\n  width:100% ;\r\n  /* padding: 24px;\r\n  border: 1px solid var(--color-gray);\r\n  border-radius: 8px;\r\n  background: var(--color-white);\r\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.06); */\r\n}\r\n\r\n.study-list-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.study-list-actions {\r\n  margin-top: auto;\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.study-list-actions .primary-button {\r\n  margin-top: 8px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .study-list-card {\r\n    flex: 1 0 100%;\r\n  }\r\n\r\n  .study-list-actions {\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n\r\n:host a {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n:host .primary-button {\r\n  color: var(--color-white) !important;\r\n}\r\n/* LSR-scoped typography and base styles */\r\n:host {\r\n  display: block;\r\n  width: 100%;\r\n  font-family: var(--font-main);\r\n}\r\n\r\n:host h1,\r\n:host h2,\r\n:host h3,\r\n:host p,\r\n:host ul {\r\n  margin: 0;\r\n}\r\n\r\n:host h1 {\r\n  font-size: 60px;\r\n  line-height: 1.2;\r\n  font-weight: 400;\r\n}\r\n\r\n:host h2 {\r\n  font-size: 30px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple);\r\n}\r\n\r\n:host p,\r\n:host ul {\r\n  font-size: 18px;\r\n  line-height: 1.18;\r\n}\r\n\r\n:host ul {\r\n  max-width: 563px;\r\n  padding-left: 24px;\r\n}\r\n\r\n:host li::marker {\r\n  font-size: 10px;\r\n}\r\n\r\n:host a {\r\n  color: inherit;\r\n}\r\n\r\n:host a.primary-button,\r\n:host a.primary-button:link,\r\n:host a.primary-button:visited {\r\n  color: var(--color-white);\r\n  text-decoration: none;\r\n}\r\n\r\n:host a.primary-button:hover,\r\n:host a.primary-button:focus-visible {\r\n  color: var(--color-white);\r\n  text-decoration: none;\r\n}\r\n\r\n:host p a {\r\n  color: var(--color-green);\r\n}\r\n\r\n:host img {\r\n  display: block;\r\n  max-width: 100%;\r\n  height: auto;\r\n  border: 0;\r\n}\r\n\r\n:host section {\r\n  scroll-margin-top: 120px;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  :host h1 {\r\n    font-size: 48px;\r\n    line-height: 1.12;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  :host h1 {\r\n    font-size: 38px;\r\n  }\r\n\r\n  :host h2 {\r\n    font-size: 26px;\r\n  }\r\n\r\n  :host p,\r\n  :host ul {\r\n    font-size: 16px;\r\n    line-height: 1.35;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
